export const addresses = {
  storeAddress:"0x2EA9EB0Fb894b560B3CA0e2F623ef9746eb98F0b",
  tokenAddress:"0x980aAc123617e2B2ea407081Ceb72d5854BAa3D1"
}
